export default __webpack_public_path__ + "2d5a895e5161d6a348ad5fe90170e615.png";